module.exports = __webpack_public_path__ + "static/undraw_page_not_found_su7k-6695af9986412e75985538255ca87866.svg";